import common from "@/util/common.js";

const state = () => ({
  dashList: [],
  total: { cost: 0, price: 0, profit: 0, ptPercent: 0 },
});

const mutations = {
  async setChart(state, payload) {
    try {
      // 0. 데이터 세팅
      state.dashList = [];
      const temp = payload.getDashboard;
      const newArray = [];
      const startDate = payload.StartDate;

      // 1. 기간 계산
      let days =
        new Date(payload.EndDate).getTime() -
        new Date(payload.StartDate).getTime();
      days = days / (1000 * 60 * 60 * 24);

      // 2. 데이터가 있는 날짜에는 데이터를 저장하고, 없는 날짜에는 0 데이터를 저장한다.
      for (let i = 0; i < days + 1; i++) {
        const day = common.calculateDate(startDate, i);
        newArray.push({
          cost: common.roundToTwo(temp[i].Cost),
          price: common.roundToTwo(temp[i].Price),
          profit: common.roundToTwo(temp[i].Profit),
          pfPercent: common.roundToTwo(temp[i].PFPercent),
          date: day,
        });
      }
      state.total.cost = common.roundToTwo(temp[temp.length - 1].Cost);
      state.total.price = common.roundToTwo(temp[temp.length - 1].Price);
      state.total.profit = common.roundToTwo(temp[temp.length - 1].Profit);
      state.total.pfPercent = common.roundToTwo(
        temp[temp.length - 1].PFPercent
      );
      var result = newArray.filter((item1, idx1) => {
        return (
          newArray.findIndex((item2, idx2) => {
            return item1.date == item2.date;
          }) == idx1
        );
      });
      console.table(result);
      state.dashList = result;
      console.log(state.dashList);
    } catch (err) {
      console.error("setChart: " + err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
